// extracted by mini-css-extract-plugin
export var box = "simple-card-module--box--90LYf";
export var hidden = "simple-card-module--hidden--lTfpD";
export var title = "simple-card-module--title--+lJxM";